import React from 'react'
import Vendordashboard from '../../Components/Vendor/VendorDashboard/Vendordashboard'
import VendorNav from '../../Components/Vendor/VendorNav/VendorNav'
function Dashboard() {
  return (
    <div>
      <VendorNav/>
      <Vendordashboard/>
    </div>
  )
}

export default Dashboard
